@for (column of columns; track column) {
  @switch (column.type) {
    @case (EnumColumnType.DATE) {
      <ng-container *ngTemplateOutlet="DateCol; context: { params: { col: column } }"></ng-container>
    }
    @case (EnumColumnType.BUTTON) {
      <ng-container *ngTemplateOutlet="ButtonCol; context: { params: { col: column } }"></ng-container>
    }
    @case (EnumColumnType.SAVED_CART_PRICE) {
      <ng-container *ngTemplateOutlet="PriceCol; context: { params: { col: column } }"></ng-container>
    }
    @default {
      <ng-container *ngTemplateOutlet="SimpleCol; context: { params: { col: column } }"></ng-container>
    }
  }
}

<ng-template #SimpleCol let-data="params">
  <app-column-control-simple
    class="table-col"
    [row]="row"
    [column]="data.col"
    [style]="data.col.cssStyle"
  ></app-column-control-simple>
</ng-template>

<ng-template #DateCol let-data="params">
  <app-column-control-date class="table-col" [row]="row" [column]="data.col"></app-column-control-date>
</ng-template>

<ng-template #ButtonCol let-data="params">
  @if (data.col.button; as btn) {
    <div class="table-col table-col-button">
      <button class="btn btn-primary btn-sm col-control-button" [disabled]="!importCompleted" (click)="onClick(btn)">
        {{ btn.title | cxTranslate }}
      </button>
    </div>
  }
</ng-template>

<ng-template #PriceCol let-data="params">
  <div class="table-col">
    <app-column-title [column]="data?.col"></app-column-title>
    @if (data.col; as col) {
      <div class="table-col-button">
        @if (importCompleted) {
          <div>{{ row[col.finalKey] }}</div>
        } @else {
          Processing
          <i class="table-col-icon" [class]="col.button.icon" (click)="onClick(col.button)"></i>
        }
      </div>
    }
  </div>
</ng-template>
